<template>
  <div class="phone-form-item-side-nav">
    <h6>{{ $t('text') }}</h6>

    <span>{{ $t('label') }}:</span>
    <Input
      :value="options.label"
      @blur="propChanged('label', $event)"
      @enter="propChanged('label', $event)"
      :disabled="true"
    />
    <Toggle :label="$t('required')" :value="options.required" @toggle="propChanged('required', $event)" />
  </div>
</template>

<script>
import Mixin from './Mixin.js'
import ComponentsMixin from '@/components/Mixin.js'

export default {
  name: 'PhoneFormItemSideNav',
  i18nOptions: { keyPrefix: 'components.sidenav.landing.form.form-item.phone' },
  mixins: [Mixin, ComponentsMixin],
}
</script>
